module.controller(
    'sampleElementDetailCtrl',
    [ '$scope', '$rootScope', '$state', 'sampleElementService', 'alertService', 'roleService', 'parameterService',
        function($scope, $rootScope, $state, sampleElementService, alertService, roleService, parameterService) {

            $scope.operationType = $state.current.data.type;
            $scope.idSampleElement = $state.params.id;
            $scope.sampleElement = {
            		//sampleElementType: {}
            };
            $scope.loading = false;
            $scope.sampleElementType=[];

            /**
             *
             * @param idSampleElement
             */
            $scope.load = function(idSampleElement) {
                $scope.loading = true;

                sampleElementService.loadSampleElement(idSampleElement).then(function(response) {
                    $scope.loading = false;

                    var responseData = response.getData();
                    //$scope.idSampleElement = responseData.id;

                    $scope.sampleElement = {
                            name : responseData.name,                            
                            sampleElementType:responseData.sampleElementType
                          };
                    
                    var setype = getConstantById(eval('SAMPLES_ELEMENT_TYPE'), responseData.sampleElementType);
                    
                    $scope.sampleElementType = [];
                    $scope.sampleElementType[0] = setype;
                }, function(response) {
                    $scope.loading = false;
                });
            };

            /**
             *{
                        username: $scope.user.username,
                        visible: $scope.user.visible,
                        firstName: $scope.user.firstName,
                        lastName: $scope.user.lastName,
                        email: $scope.user.email
                    };
             */
            $scope.sendAction = function() {
                if ($scope.operationType == 'create') {
                    $scope.create();
                } else {
                    $scope.update();
                }
            };

            /**
             *
             */
            $scope.create = function() {
                alertService.showSwtQuestion('Crear elemento de Muestreo', function() {
                    $scope.loading = true;

                    var createModel = {
                        name: $scope.sampleElement.name,
                        sampleElementType: $scope.sampleElementType[0].enumName
                    };                    

                    sampleElementService.createSampleElement(createModel).then(function(response) {
                        $scope.loading = false;
                        $state.go('home.sampleElementList');
                        alertService.showSuccess('Elemento de muestreo creado satisfactoriamente');
                    }, function(response) {
                        $scope.loading = false;
                    });
                });
            };

            /**
             *
             */
            $scope.update = function() {
                alertService.showSwtQuestion('Actualizar Elemento de Muestreo', function() {
                    $scope.loading = true;

                    var updateModel = {
                            name: $scope.sampleElement.name,
                            sampleElementType: $scope.sampleElementType[0].enumName
                        };                 

                    sampleElementService.updateSampleElement($scope.idSampleElement, updateModel).then(function(response) {
                        $scope.loading = false;
                        $state.go('home.sampleElementList');
                        alertService.showSuccess('Elemento de muestreo actualizado satisfactoriamente');
                    }, function(response) {
                        $scope.loading = false;
                    });
                });
            };


            if ($scope.operationType == 'update') {
                $scope.load($state.params.id);
            }

        } ]);


